// The Create page's address (#/create), apart from the page so the app can check it
// without loading the page's code.
export const parseCreateHash = (hash = window.location.hash) => (/^#\/create(?:[/?]|$)/.test(hash) ? {} : null);

// Community Intel (#/community, #/community/submit, …/mine, …/review): the tab is the second part.
export const parseCommunityHash = (hash = window.location.hash) => {
  const m = hash.match(/^#\/community(?:\/([a-z]+))?(?:[?]|$)/);
  return m ? { tab: m[1] || "reports" } : null;
};
